import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './services/analytics.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'weatherForecast';
  deleteUser: boolean = false;


  constructor(private router : Router,
    private analyticsService: AnalyticsService
  ) {

  }
  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.analyticsService.trackPageView(event.urlAfterRedirects);
      this.deleteUser = event.url === '/deleteUser';      
    });
  }


}

